<template>
  <wo-region v-if="salesPoint">
    <wo-layout>
      <wo-title tag-name="h3">{{ salesPoint.company.name }}</wo-title>
    </wo-layout>
    <wo-layout>
      <wo-grid>
        <wo-column width-md="7">
          <sales-point-props :value="salesPoint" mod-info>
            <po-route-link :value="editRoute" v-t="'general.action.edit'" slot="actions" />
            <po-action-dropdown :actions="actions" slot="actions" mod-right />
          </sales-point-props>
          <wo-spacer />
          <sales-point-props :value="salesPoint" :tags="tags" mod-flags />
          <wo-spacer />
        </wo-column>
        <wo-column width-md="5">
          <address-props :value="salesPoint.company.address" :address-name="salesPoint.company.name" mod-props mod-map />
          <wo-spacer />
        </wo-column>
      </wo-grid>
    </wo-layout>
  </wo-region>
</template>

<script>

import { mapState } from 'vuex'
import { showConfirmation } from '@/modal'

import { salesPointRepository, salesPointTagRepository } from '@/repository/sales-point'

import { SALES_POINT_EDIT, SALES_POINT_LIST } from '@/routes/sales-point'

import SalesPointProps from '@/components/sales-point/SalesPointProps'
import AddressProps from '@/components/geography/AddressProps'

export default {
  components: { SalesPointProps, AddressProps },
  props: {
    salesPointId: [String, Number]
  },
  computed: mapState({
    salesPoint: state => state.salesPoint.salesPoint,
    tags: state => state.salesPoint.salesPointTagList && state.salesPoint.salesPointTagList.items,
    actions () {
      return [{ id: 'delete', labelKey: 'general.action.delete', execute: this.deleteSalesPoint }]
    },
    editRoute () {
      return { name: SALES_POINT_EDIT }
    }
  }),
  created () {
    this.loadSalesPoint()
  },
  watch: {
    salesPointId () {
      this.loadSalesPoint()
    }
  },
  methods: {
    loadSalesPoint () {
      this.$store.dispatch(salesPointRepository.find, { id: this.salesPointId })
      this.$store.dispatch(salesPointTagRepository.findAll, { salesPointId: this.salesPointId })
    },
    deleteSalesPoint () {
      showConfirmation({ messageKey: 'salespoint.confirmDelete' }, this.confirmDelete)
    },
    confirmDelete () {
      return this.$store.dispatch(salesPointRepository.delete, { id: this.salesPointId })
        .then(() => this.$router.push({ name: SALES_POINT_LIST }))
    }
  }
}
</script>
